import { render, staticRenderFns } from "./ReuseTab.vue?vue&type=template&id=1ed57e34&scoped=true&"
import script from "./ReuseTab.vue?vue&type=script&lang=js&"
export * from "./ReuseTab.vue?vue&type=script&lang=js&"
import style0 from "./ReuseTab.vue?vue&type=style&index=0&id=1ed57e34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed57e34",
  null
  
)

export default component.exports